import { defineMessages } from 'react-intl';
export default defineMessages({
    account: {
        id: 'account.account',
        defaultMessage: 'Profile & Security'
    },
    accountDeleted: {
        id: 'account.accountDeleted',
        defaultMessage: 'Your account has been successfully deleted.'
    },
    accountDescription: {
        id: 'account.accountDescription',
        defaultMessage: 'Name, password, delete account'
    },
    accountSection: {
        id: 'account.accountSection',
        defaultMessage: 'Account'
    },
    changeEmail: {
        id: 'account.changeEmail',
        defaultMessage: 'Change email'
    },
    changePassword: {
        id: 'account.changePassword',
        defaultMessage: 'Change password'
    },
    currentPassword: {
        id: 'account.currentPassword',
        defaultMessage: 'Current password'
    },
    dangerZone: {
        id: 'account.dangerZone',
        defaultMessage: 'Danger zone'
    },
    deleteAccount: {
        id: 'account.deleteAccount',
        defaultMessage: 'Delete your account'
    },
    deleteAccountConfirmation: {
        id: 'account.deleteAccountConfirmation',
        defaultMessage: 'Are you sure you want to delete your account? This action is irreversible.'
    },
    deleteAccountDescription: {
        id: 'account.deleteAccountDescription',
        defaultMessage: 'This action deletes your account and all your information. There is no going back.'
    },
    emailChange: {
        id: 'account.emailChange',
        defaultMessage: 'Change email address'
    },
    emailChangeConfirmation: {
        id: 'account.emailChangeConfirmation',
        defaultMessage: 'Email Change Confirmation'
    },
    emailChangeIntro: {
        id: 'account.emailChangeIntro',
        defaultMessage: 'Enter your new email address and your current password. We will send a link to the new address: your email changes only once you open it.'
    },
    emailChangeFailure: {
        id: 'account.emailChangeFailure',
        defaultMessage: 'The email change link is invalid or has expired.'
    },
    emailChangeSuccess: {
        id: 'account.emailChangeSuccess',
        defaultMessage: 'Your email has been successfully changed to {newEmail}.'
    },
    emailChangeSuccessNoAddress: {
        id: 'account.emailChangeSuccessNoAddress',
        defaultMessage: 'Your email address has been successfully changed.'
    },
    emailChangeVerificationSent: {
        id: 'account.emailChangeVerificationSent',
        defaultMessage: 'A verification email has been sent to your new email address. Please check your inbox and click the link to confirm the change.'
    },
    manageAccount: {
        id: 'account.manageAccount',
        defaultMessage: 'Manage account'
    },
    newEmailAddress: {
        id: 'account.newEmailAddress',
        defaultMessage: 'New email address'
    },
    newPassword: {
        id: 'account.newPassword',
        defaultMessage: 'New password'
    },
    newPasswordAgain: {
        id: 'account.newPasswordAgain',
        defaultMessage: 'New password again'
    },
    oldPassword: {
        id: 'account.oldPassword',
        defaultMessage: 'Old password'
    },
    passwordChange: {
        id: 'account.passwordChange',
        defaultMessage: 'Password change'
    },
    passwordChangeDescription: {
        id: 'account.passwordChangeDescription',
        defaultMessage: 'Keep your account secure'
    },
    passwordUpdated: {
        id: 'account.passwordUpdated',
        defaultMessage: 'Password successfully updated.'
    },
    profile: {
        id: 'account.profile',
        defaultMessage: 'Profile'
    },
    profileUpdated: {
        id: 'account.profileUpdated',
        defaultMessage: 'Profile successfully updated.'
    },
    signedInAs: {
        id: 'account.signedInAs',
        defaultMessage: 'Signed in as'
    },
    updateYourProfile: {
        id: 'account.updateYourProfile',
        defaultMessage: 'Update your profile'
    },
    updateYourProfileDescription: {
        id: 'account.updateYourProfileDescription',
        defaultMessage: 'Name and display preferences'
    }
});
